import { ApiClient, type ApiClientOptions } from '@/infra/api-client'
import type { FlockRelationshipManagerResource } from '@/features/relation-manager/api/resources/flock-relationship-manager'

/**
 * Collection of APIs for Flock.
 */
export class FlockApi {
  readonly relationshipManagers

  constructor(options: ApiClientOptions) {
    this.relationshipManagers = new FlockRelationshipManagerApi(options)
  }
}

export class FlockRelationshipManagerApi extends ApiClient {
  get(
    jobId: string,
    signal?: AbortSignal,
  ): Promise<FlockRelationshipManagerResource> {
    return this._get(
      `v1/relationship-managers/jobs/${encodeURIComponent(jobId)}`,
      undefined,
      { signal },
    )
  }
}
